import React from 'react';

import { InjectedIntl } from 'react-intl';

import ShortcutIcon from '@atlaskit/icon/glyph/shortcut';

import messages from './accessibility.i18n';
import { ScreenReadersOnly } from './accessibility.style';

/**
 * A component with two elements that indicate a link will open in a new tab or window:
 * - Visually hidden text for screen readers
 * - Visible shortcut icon
 *
 * This component is recommended for use as an inline element after link text inside
 * links that open new windows or tabs. We avoid use of the `iconAfter` prop due to
 * flex CSS rules that change the icon placement.
 */
export const ExternalLinkInlineIcon = ({ intl }: { intl: InjectedIntl }) => {
  return (
    <>
      <ScreenReadersOnly>
        {intl.formatMessage(messages.opensInNewWindow)}
      </ScreenReadersOnly>{' '}
      <ShortcutIcon label="" size="small" />
    </>
  );
};
